import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSearchRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M21.6 13.6a8 8 0 1 0-16 0 8 8 0 0 0 16 0m-1.5 8.2q-2.7 2.1-6.5 2.2a10.4 10.4 0 1 1 8.2-4l6.6 6.8c.5.4.5 1.2 0 1.6q-.8.8-1.6 0z" })
});
export default SvgSearchRegularIcon;
